import PageHeader from "@/components/PageHeader";
import HowItWorks from "@/sections/HowItWorks";
import Feedback from "@/sections/Feedback";
import Marquee from "@/components/Marquee";

export default function HowItWorksPage() {
  return (
    <>
      <PageHeader
        testid="how-it-works-header"
        eyebrow="Nasıl Çalışır"
        titleLines={["Beş adımda", "daha kişisel bir süreç."]}
        lede="Five Star'da eşleşme anlık bir kaydırma değildir. Seni tanıyan, geri bildirimlerinle öğrenen ve süreç boyunca yanında olan bir deneyimdir."
      />
      <HowItWorks showLink={false} />
      <Marquee items={["Seni tanıyan bir dating deneyimi", "Daha az rastgelelik, daha fazla özen", "Her eşleşme bir sürecin parçası"]} />
      <Feedback />
    </>
  );
}
